export const ROUTES = {
  home: "/",

  RACK_PRICING: {
    verify: "/verify",
    rackConfirmation: "/rack-confirmation",
    rackPricing: "/rack-pricing",
    benchmarkEntry: "/benchmark-entry",
    wetMove: "/wet-move",
    dtnUpload: "/dtn-upload",
    rackPricingWeekendHoliday: "/rack-pricing-weekend-holiday",
    rackConfirmationWeekendHoliday: "/rack-confirmation-weekend-holiday",
  },

  RACK_FEATURES: {
    outage: "/outage",
    rackDefinition: "/rack-definition",
    formula: "/formula",
    terminalGroup: "/terminal-group",
    rackNote: "/rack-note",
    rackPricingGroup: "/rack-pricing-group",
    salesRep: "/sales-rep",
    customerRackEmail: "/customer-rack-email",
    allocation: "/allocation",
    customerRackSelection: "/customer-rack-selection",
    formulaOPIS: "/formula-opis",
    rackMessaging: "/rack-messaging",
  },

  BID_PRICING: {
    bidPricing: "/bid-pricing",
    bidConfirmation: "/bid-confirmation",
  },

  BID_FEATURES: {
    bidDefinition: "/bid-definition",
    bidFreight: "/bid-freight",
    customerPricingSetup: "/customer-pricing-setup",
    bidTerminalGroup: "/bid-terminalgroup",
    customerBidEmail: "/customer-bid-email",
  },

  REPORTS: {
    bidPriceFloor: "/bid-price-floor",
    customerBidPricing: "/customer-bid-pricing",
    opisLowReport: "/opis-low-report",
    customerContractReport: "/customer-contract-report",
    rackPricingReport: "/rack-pricing-report",
    bidPricingReport: "/bid-pricing-report",
    rackContractReport: "/rack-contract-report",
    customerTerminalReport: "/customer-terminal-report",
    sumnerCountyReport: "/sumner-county-report",
    transportPickListReport: "/transport-pick-list-report",
    productSupplyReport: "/product-supply-report",
    bidMarginReport: "/bid-margin-report",
    pdiCostMarginReport: "/pdi-cost-margin-report",
    fastRacksReport: "/fast-racks-report",
  },

  SETUP: {
    calendarSchedule: "/calendar-schedule",
    customer: "/customer",
    dtnCity: "/dtn-city",
    fastRacks: "/fastracks",
    fuelSupplier: "/fuel-supplier",
    fuelSupplierCostMap: "/fuel-supplier-cost-map",
    opisCity: "/opis-city",
    pdiPricingSetup: "/pdi-pricing-setup",
    pdiSync: "/pdi-sync",
    fuelProduct: "/fuel-product",
    settings: "/settings",
    states: "/states",
    tax: "/tax",
    terminal: "/terminal",
    timeSetup: "/time-setup",
    verifyBenchmark: "/verify-benchmark",
    storedProcs: "/stored-procs",
  },

  bidFeatures: "/bid-features",
  bidPricingFeatures: "/bid-pricing-features",
  login: "/login",
  quartz: "/quartz",
  logs: "/logs",
  rackFeatures: "/rack-features",
  rackPricingFeatures: "/rack-pricing-features",
  reports: "/reports",
  setup: "/setup",
  fallback: "*", // for 404 redirects
};
